import Config from '../config/config';
import axios from 'axios';

const { baseURL } = Config.API;

const getOverviewData = async (queryParams) => {
  return axios({
    method: 'GET',
    baseURL,
    url: '/overview/',
    params: queryParams
  });
};

export default {
  getOverviewData
};
